'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import { DropTarget } from 'react-dnd';
import { jsx as _jsx } from "react/jsx-runtime";
const dropTypes = [DRAG_TYPES.ADD_MODULE, 'WIDGETS'];
const dropSpec = {
  hover(props) {
    const {
      currentTargetDropIndex,
      dropIndex,
      updateCurrentDropTarget
    } = props;
    // Only update the current drop target if its different
    if (currentTargetDropIndex !== dropIndex) {
      updateCurrentDropTarget(dropIndex);
    }
  },
  drop(props, monitor) {
    if (monitor.didDrop() && monitor.getDropResult()) {
      return null;
    }
    const {
      currentTargetDropIndex,
      flexDropColumnId
    } = props;
    return {
      dropIndex: currentTargetDropIndex,
      flexDropColumnId
    };
  }
};
const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
});
class FlexColumnEmptyDropPlaceHolder extends Component {
  render() {
    const {
      connectDropTarget,
      isOver
    } = this.props;
    const dropClasses = 'hs-ipe-flex-column-dropzone' + (isOver ? " hs-ipe-flex-column-dropzone-over" : "");
    return connectDropTarget( /*#__PURE__*/_jsx("div", {
      "data-hs-dragdrop": true,
      children: /*#__PURE__*/_jsx("div", {
        className: dropClasses
      })
    }));
  }
}
FlexColumnEmptyDropPlaceHolder.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  currentTargetDropIndex: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  dropIndex: PropTypes.number.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  flexDropColumnId: PropTypes.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  isOver: PropTypes.bool.isRequired,
  updateCurrentDropTarget: PropTypes.func.isRequired // eslint-disable-line react/no-unused-prop-types
};
export default DropTarget(dropTypes, dropSpec, dropCollect)(FlexColumnEmptyDropPlaceHolder);